import React from 'react';
import './ProgressBubbles.scss'

function ProgressBubbles(props){
    const generateBubbles = () => {
        let jsx = [];
        for(let i = 1; i <= props.total; i++){
            if(i < props.current){
                jsx.push(<div key={i} className="bubble filled"></div>)
            }else if(i === props.current){
                jsx.push(<div key={i} className="bubble current"></div>)
            }
            else{
                jsx.push(<div key={i} className="bubble empty"></div>)
            }
        }
        return jsx;
    }
    return (
        <div className="ProgressBubbles">
            {generateBubbles()}
        </div>
    )
}

export default ProgressBubbles;
